import React, {FC} from "react"
import {CollectionName} from "../../../constants"
import AnimationComponent from "../../reusable/components/AnimationComponent/AnimationComponent"
import FilterModalContentMobile from "./FilterModalContentMobile"

type Props ={
	isOpen: boolean
	productsPriceRange: any
	filters: any[]
	collectionName: CollectionName
	handleClose: ()=>void
	customUrlBaseValue?: string
}

const FilterModal: FC<Props> = ({isOpen, productsPriceRange, filters, collectionName, handleClose, customUrlBaseValue}) => {
	return (
		<>
			<AnimationComponent inProp={isOpen}
				type="fade">
				<div className="position-fixed vh-100 vw-100"
					style={{
						backgroundColor: "rgba(0,0,0,0.8)",
						zIndex: 9999999,
						top: 0, left: 0
					}}
					onClick={handleClose}>
				</div>
			</AnimationComponent>
			<AnimationComponent inProp={isOpen}
				type="slideUp">
				<FilterModalContentMobile customUrlBaseValue={customUrlBaseValue}
					collectionName={collectionName}
					productsPriceRange={productsPriceRange}
					filters={filters}
					closeModal={handleClose}/>
			</AnimationComponent>
		</>
	)
}

export default FilterModal
